import React from 'react';

import { IGridCell } from '../../../../../ui/types/IGridCell';

import { Tooltip } from '@progress/kendo-react-tooltip';
import { Link } from 'react-router-dom';
import LoadingCell from '../../../../../ui/table/cells/loadingCell/loadingCell';

import './agreementNameCell.scss';

const AgreementNameCell: React.FC<IGridCell> = ({rowType, dataItem, field, width}) => {
  if (rowType === 'groupHeader') {
    return null;
  }

  if (dataItem[field] === undefined) return <LoadingCell />;

  return (
    <td className='agreement-name-cell' style={{ width:width }}>
      <Tooltip anchorElement='target'>
        <div className='agreement-name-wrapper'>
          <Link to={`/agreements/${dataItem.agreementId}`} state={dataItem}>
              <span title={dataItem[field]} className='pointer'>
                {dataItem[field]}
              </span>
          </Link>
        </div>
      </Tooltip>
    </td>
  );
};

export default AgreementNameCell;
